const axios = require('axios')

const loadHtml = async (htmlRelativeUrl, baseUrl, httpRequest = axios) => {
  const htmlUrl = new URL(htmlRelativeUrl, baseUrl).href;
  return await httpRequest.get(htmlUrl)
}

module.exports = loadHtml